// extracted by mini-css-extract-plugin
module.exports = {"dropBox":"FileDropBox_dropBox__35KvP","photos":"FileDropBox_photos__1K_dV","documentsItems":"FileDropBox_documentsItems__tTWSw","photosItems":"FileDropBox_photosItems__11UWZ"};